module.exports = __webpack_public_path__ + "static/mangochango_merge-67c371f5f5b75416b67e569ea26ccc01.png";